export const ENDPOINTS = {
    LOGIN: '/oauth/client/oauth2/token',
    REFRESH: '/oauth/client/oauth2/token',
    UPDATE_TOKEN: '/oauth/oauth2/token',
    UPDATE_USER_SETTINGS: '/oauth/oauth2/user/settings',
    RESET_PASSWORD: '/oppapi/client/v2/password-reset',
    CHANGE_PASSWORD: '/oppapi/client/v2/password',
    CONFIRM_EMAIL: '/oppapi/client/v1/validation',
    SET_DEFAULT_MERCHANT: '/oauth/oauth2/user/default-merchant',
    TEAMMATES_API: '/oppapi/v1/teammates',
    MERCHANT_STORES_API: '/oppapi/v1/merchants/stores',
    GET_INVOICES: '/oppapi/v1/invoices',
    GET_INVOICE: (id: string) => `/oppapi/v1/invoices/${id}`,
    SEND_EMAIL_OTP: '/oauth/oauth2/email/otp?type=twoFAEnable',
    PDF_STATEMENT: '/oppapi/v1/pdf-statement'
}
